import { render, staticRenderFns } from "./bloodGlucoseCollaborative.vue?vue&type=template&id=3682fd30"
import script from "./bloodGlucoseCollaborative.vue?vue&type=script&lang=js"
export * from "./bloodGlucoseCollaborative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports